import { c as _c } from "react/compiler-runtime";
export function GrantErrorDetails(t0) {
  const $ = _c(3);
  const {
    message
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <p className="tw-m-0 tw-text-xs tw-font-semibold tw-uppercase tw-text-red-300">Error details</p>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== message) {
    t2 = <section aria-live="polite" className="tw-rounded-lg tw-border tw-border-red-500/40 tw-bg-red-500/5 tw-p-3 tw-text-red-200">{t1}<p className="tw-m-0 tw-mt-1 tw-whitespace-pre-line tw-text-sm">{message}</p></section>;
    $[1] = message;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}